import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/layout/Layout';
import GlobalStyles from './styles/globalStyles';
import Notifications from './components/common/Notifications';
import { ToastProvider } from './components/common/ToastProvider';

// Pages
import LandingPage from './pages/LandingPage';
import Dashboard from './pages/Dashboard';
import Policies from './pages/Policies';
import Claims from './pages/Claims';
import Analytics from './pages/Analytics';
import Settings from './pages/Settings';
import Manage from './pages/Manage';
import EmptyPage from './pages/EmptyPage';
import Login from './pages/Login';
import AgentStudio from './pages/AgentStudio';
import MissionControl from './pages/MissionControl';
import ClaimsTriage from './pages/ClaimsTriage';
import ClaimDetails from './pages/ClaimDetails';
import UnderwritingDetails from './pages/UnderwritingDetails';
import UnderwritingHub from './pages/UnderwritingHub';
import DocumentQueue from './pages/DocumentQueue';
import FraudVault from './pages/FraudVault';
import Personas from './pages/Personas';
import ModelHub from './pages/ModelHub';
import Performance from './pages/Performance';
import KnowledgeBase from './pages/KnowledgeBase';
import Workflows from './pages/Workflows';
import Observability from './pages/Observability';
import FeedbackLoops from './pages/FeedbackLoops';
import SecurityGovernance from './pages/SecurityGovernance';
import DataSources from './pages/DataSources';
import PromptLibrary from './pages/PromptLibrary';
import AgentPipelines from './pages/AgentPipelines';
import Tools from './pages/Tools';
import PipelineDesigner from './pages/PipelineDesigner';
import EntityList from './pages/Entity';
import EntityDetails from './pages/EntityDetail';
import KnowledgebaseDetails from './pages/KnowledgebaseDetail';
import KnowledgeBaseQuery from './pages/KnowledgeBaseQuery';
import ModelHubDetails from './pages/ModelHubDetails';
import Connector from './pages/Connector';
import ConnectorDetails from './pages/ConnectorDetails';
import Services from './pages/Services';
import ServicingDetails from './pages/ServicesDetails';

// Context
import { AuthProvider } from './context/AuthContext';
import EntityRecords from './pages/EntityList';
import DataSourceDetails from './pages/DataSourceDetails';
import PersonaDetails from './pages/PersonasDetails';
import PromptLibraryDetails from './pages/PromptLibrary-details';
import PipelineAnalytics from './pages/PipelineAnalytics';
import CompanyCreation from './pages/CompanyCreation';
import Company from './pages/Company';
import ClaimsHub from './pages/ClaimsHub';
import ClaimsHubDetails from './pages/ClaimsHubDetails';
import WorkStreamDetails from './pages/AllDetails';
import WorkStreamHub from './pages/AllListing';

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <Router>
          <GlobalStyles />
          <Notifications />
          <Routes>
            {/* Login route */}
            <Route path="/login" element={<Login />} />
            <Route path="/login/:provider" element={<Login />} />
            {/* Main application routes with layout */}
            <Route path="/" element={
              <ProtectedRoute>
                <Layout>
                  <LandingPage />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            } />
            
            {/* Automation Workspace */}
            <Route path="/mission-control" element={
              <ProtectedRoute>
                <Layout>
                  <MissionControl />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/claims-hub" element={
              <ProtectedRoute>
                <Layout>
                  <ClaimsHub />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/workstream-hub/:workstreamname" element={
              <ProtectedRoute>
                <Layout>
                  <WorkStreamHub />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/workstream-details/:workstreamname/:id" element={
              <ProtectedRoute>
                <Layout>
                  <WorkStreamDetails />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/new-business-details/:id" element={
              <ProtectedRoute>
                <Layout>
                  <UnderwritingDetails />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/new-business-hub" element={
              <ProtectedRoute>
                <Layout>
                  <UnderwritingHub />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/document-queue" element={
              <ProtectedRoute>
                <Layout>
                  <DocumentQueue />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/services" element={
              <ProtectedRoute>
                <Layout>
                  <Services />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/service-details/:id" element={
              <ProtectedRoute>
                <Layout>
                  <ServicingDetails />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/fraud-vault" element={
              <ProtectedRoute>
                <Layout>
                  <FraudVault />
                </Layout>
              </ProtectedRoute>
            } />
            
            {/* Agent Ecosystem */}
            <Route path="/agent-studio" element={
              <ProtectedRoute>
                <Layout>
                  <AgentStudio />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/personas" element={
              <ProtectedRoute>
                <Layout>
                  <Personas />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/personas-details/:personaId" element={
              <ProtectedRoute>
                <Layout>
                  <PersonaDetails />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/model-hub" element={
              <ProtectedRoute>
                <Layout>
                  <ModelHub />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/model-hub-details/:modelId" element={
              <ProtectedRoute>
                <Layout>
                  <ModelHubDetails />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/connector" element={
              <ProtectedRoute>
                <Layout>
                  <Connector />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/connector-details/:connectorId" element={
              <ProtectedRoute>
                <Layout>
                  <ConnectorDetails />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/tools" element={
              <ProtectedRoute>
                <Layout>
                  <Tools />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/performance" element={
              <ProtectedRoute>
                <Layout>
                  <Performance />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/pipeline-designer/:pipelineId" element={
              <ProtectedRoute>
                <Layout>
                  <PipelineDesigner />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/pipeline-analytics/:pipelineId" element={
              <ProtectedRoute>
                <Layout>
                  <PipelineAnalytics />
                </Layout>
              </ProtectedRoute>
            } />
            
            {/* Knowledge & Flows */}
            <Route path="/knowledge-base" element={
              <ProtectedRoute>
                <Layout>
                  <KnowledgeBase />
                </Layout>
              </ProtectedRoute>
            } />
            
            <Route path="/knowledge-base-details/:knowledgebaseId" element={
              <ProtectedRoute>
                <Layout>
                  <KnowledgebaseDetails />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/knowledge-base-query/:knowledgebaseId" element={
              <ProtectedRoute>
                <Layout>
                  <KnowledgeBaseQuery />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/workflows" element={
              <ProtectedRoute>
                <Layout>
                  <Workflows />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/entity" element={
              <ProtectedRoute>
                <Layout>
                  <EntityList />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/entity-details/:entityId" element={
              <ProtectedRoute>
                <Layout>
                  <EntityDetails />
                </Layout>
              </ProtectedRoute>
            } />
            
            <Route path="/entity-lists/:entityId" element={
              <ProtectedRoute>
                <Layout>
                  <EntityRecords />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/data-sources" element={
              <ProtectedRoute>
                <Layout>
                  <DataSources />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/data-sources-details/:dsId" element={
              <ProtectedRoute>
                <Layout>
                  <DataSourceDetails />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/prompt-library" element={
              <ProtectedRoute>
                <Layout>
                  <PromptLibrary />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/prompt-details/:promptId" element={
              <ProtectedRoute>
                <Layout>
                  <PromptLibraryDetails />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/agent-pipelines" element={
              <ProtectedRoute>
                <Layout>
                  <AgentPipelines />
                </Layout>
              </ProtectedRoute>
            } />
            
            {/* Governance */}
            <Route path="/security-governance" element={
              <ProtectedRoute>
                <Layout>
                  <SecurityGovernance />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/observability" element={
              <ProtectedRoute>
                <Layout>
                  <Observability />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/policies" element={
              <ProtectedRoute>
                <Layout>
                  <Policies />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/feedback-loops" element={
              <ProtectedRoute>
                <Layout>
                  <FeedbackLoops />
                </Layout>
              </ProtectedRoute>
            } />
            
            {/* System */}
            <Route path="/analytics" element={
              <ProtectedRoute>
                <Layout>
                  <Analytics />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/settings" element={
              <ProtectedRoute>
                <Layout>
                  <Settings />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/manage" element={
              <ProtectedRoute>
                <Layout>
                  <Manage />
                </Layout>
              </ProtectedRoute>
            } />

              <Route path="/manage/company/:id" element={
              <ProtectedRoute>
                <Layout>
                  <CompanyCreation />
                </Layout>
              </ProtectedRoute>
            } />

               <Route path="/create/company/" element={
              <ProtectedRoute>
                <Layout>
                  <CompanyCreation />
                </Layout>
              </ProtectedRoute>
            } />

            <Route path="/company" element={
              <ProtectedRoute>
                <Layout>
                  <Company />
                </Layout>
              </ProtectedRoute>
            } />
            
            {/* Legacy routes - can be removed if not needed */}
            <Route path="/claims" element={
              <ProtectedRoute>
                <Layout>
                  <Claims />
                </Layout>
              </ProtectedRoute>
            } />
            
            {/* Default redirect to login */}
            <Route path="*" element={
              <ProtectedRoute>
                <Layout>
                  <Navigate to="/login" replace />
                </Layout>
              </ProtectedRoute>
            } />
          </Routes>
        </Router>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
